<template>
  <div class="father">
    <div
      v-if="videoList && videoList[selectIndex] && videoList[selectIndex].src"
    >
      <video
        class="video"
        controls
        :style="video_style"
        :src="videoList && videoList[selectIndex] && videoList[selectIndex].src"
        type="video/mp4"
      ></video>
    </div>
    <div
      :style="video_style"
      style="width: 200px !important"
      class="right-list"
    >
      <el-scrollbar
        wrapStyle="overflow-x:hidden;"
        :style="video_style"
        style="width: 200px !important; overflow: hidden"
      >
        <div class="video-fa">
          <div
            class="video-item"
            v-for="(item, index) in videoList"
            :key="index"
            @click="showVideo(index)"
            :class="index == selectIndex ? 'video-clicked' : ''"
          >
            <div>
              <div class="label">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { getVideoUrl } from "@/api/index.js";
export default {
  name: "tigerzzvideo",
  data() {
    return {
      videoList: [],
      selectIndex: 0,
      video_style: "",
    };
  },
  computed: {
    availWH() {
      return this.$store.state.resolution.availWH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    },
  },
  watch: {
    availWH: {
      handler(newinner, oldinner) {
        // this.menu_show = false;

        this.video_style = `height:${newinner.availHeight - 250}px;width:${
          newinner.availWidth - 500
        }px`;
        console.log(this.video_style);
        /* if (newinner.innerHeight < 740) {
          this.header_style = "height:60px;";
        } else {
          this.header_style = "height:80px;";
        } */
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    const res = await getVideoUrl();
    console.log("res---------------", res);
    this.videoList = res;
    /* .map((item, index) => {
        return {
          ...item,
          show: false,
        };
      });
      */

    console.log(this.videoList);
    console.log(this.availWH);
    console.log(this.innerWH);
  },
  methods: {
    showVideo(index) {
      this.selectIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.father {
  height: calc(100vh - 190px);
  width: 100%;
  padding: 20px;

  // background-color: red;
}
.right-list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  width: 220px !important;
  box-shadow: inset 0 0 100px #929292;
  padding: 10px;
}
.video-fa {
  width: 200px;
  height: auto;

  .video-item {
    .label {
      font-size: 20px;
      font-weight: 700;
      cursor: pointer;
      padding: 10px;
    }
  }
}
.video-clicked {
  background-color: #409eff;
  color: #fff;
}
.video {
  height: calc(100vh - 190px);
}
</style>
